import React from 'react';
import {
	Placeholder,
	ChooseTermMask,
	ChooseTermMaskRight,
	TermsYAxis,
	TermsXAxis,
	TermsMarginBottom,
	SubtotalMaskRight,
} from './placeholderTermsStyles';

const PlaceholderTerms = () => {
	return (
		<Placeholder>
			<ChooseTermMaskRight />
			<ChooseTermMask />
			<TermsYAxis />
			<TermsXAxis />
			<TermsMarginBottom />
			{/* Hiding subtotal for now... */}
			{ false && (
				<>
					<SubtotalMaskRight />
				</>
			)}
		</Placeholder>
	);
};

export default PlaceholderTerms;
